export function snackbarAction(state = null, action) {
  switch (action.type) {
    case 'OPEN_SNACKBAR':
      return action.action || state;
    case 'CLOSE_SNACKBAR':
      return null;
    default:
      return state;
  }
}
